import React from "react";
import { OrderSummaryProps } from "../types/dashboard";
import PieCharts from "../pie-charts/PieCharts";

const OrderSummary: React.FC<OrderSummaryProps> = ({
  title, 
  orders, 
  amount, 
  received, 
  outstanding = 0, 
  Discount = 0, 
  orderDiscount = 0, // New
  ledgerDiscount = 0, // New
  DeliveryFee = 0, 
  ParcelFee = 0, 
  tips = 0, 
  timeRange, 
  businessType, 
  showParcelFee = false, 
  showTips = false,
  todaysOrderReceived = 0,
  outstandingLedgerReceived = 0,
  receivedLabels
}) => {
  return (
    <div className="rounded-xl shadow-md h-full flex flex-col bg-white">
      <div className="flex-1 p-4">
        <PieCharts
          title={title}
          Orders={orders}
          amount={amount}
          todaysOrderReceived={todaysOrderReceived}
          outstandingLedgerReceived={outstandingLedgerReceived}
          ReceivedAmount={received}
          OutstandingAmount={outstanding}
          Discount={Discount}
          orderDiscount={orderDiscount} // New
          ledgerDiscount={ledgerDiscount} // New
          DeliveryFee={DeliveryFee}
          ParcelFee={showParcelFee ? ParcelFee : 0}
          tips={showTips ? tips : 0}
          timeRange={timeRange}
          businessType={businessType}
          showParcelFee={showParcelFee}
          showTips={showTips}
          receivedLabels={receivedLabels}
        />
      </div>
    </div>
  );
};

export default OrderSummary;